function capitalizeFirstLetter(string: string) {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}

function getCleanMediaName(name?: string): string {
    return name ? name.replace(/[a-zA-Z\d]*\*_\*/g, '') : '';
}

export { capitalizeFirstLetter, getCleanMediaName };
